import React from 'react';
import styles from '../../WabaChats.module.scss';
import { isWindowOpen } from '../../windowStatus';

function formatTime(isoString) {
    if (!isoString) return '';
    const date = new Date(isoString);
    const now = new Date();
    if (date.toDateString() === now.toDateString()) {
        return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    }
    return date.toLocaleDateString([], { day: '2-digit', month: '2-digit' });
}

export default function ConversationItem({ conversation, isActive, onClick }) {
    const { customer_name, customer_phone, last_message, unread_count, last_message_at } = conversation;
    const displayName = customer_name || customer_phone;
    const preview = last_message?.content || '';
    const direction = last_message?.direction;
    const open = isWindowOpen(conversation);
    return (
        <div
            className={`${styles.conversationItem} ${isActive ? styles.active : ''} ${open ? styles.convOpen : styles.convClosed}`}
            onClick={onClick}
            title={open ? 'Можно ответить обычным сообщением' : 'Окно 24ч закрыто — обычное сообщение отправить нельзя'}
        >
            <div className={styles.convAvatar}>{displayName.charAt(0).toUpperCase()}</div>
            <div className={styles.convInfo}>
                <div className={styles.convTop}>
                    <span className={styles.convName}>
                        {open && <span className={styles.convOpenDot} />}
                        {displayName}
                    </span>
                    <span className={styles.convTime}>{formatTime(last_message_at)}</span>
                </div>
                <div className={styles.convBottom}>
                    <span className={styles.convPreview}>{direction === 'outbound' ? 'You: ' : ''}{preview.substring(0, 50)}</span>
                    {unread_count > 0 && <span className={styles.convBadge}>{unread_count}</span>}
                </div>
            </div>
        </div>
    );
}
